import { render, staticRenderFns } from "./create-v2.vue?vue&type=template&id=0cbaa412&scoped=true&"
import script from "./create-v2.vue?vue&type=script&lang=js&"
export * from "./create-v2.vue?vue&type=script&lang=js&"
import style0 from "./create-v2.vue?vue&type=style&index=0&id=0cbaa412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbaa412",
  null
  
)

export default component.exports